// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "0.0.18/static/js/" + chunkId + "." + "c237f865" + ".chunk.js";
};